import {
  ITicketState,
  TicketActionTypes,
  TICKET_TOGGLE_MODAL_LOADING,
  TICKET_TOGGLE_ESCALATION_MODAL_LOADING,
  TICKET_ESCALATE_TICKET,
  TOGGLE_TICKET_REASON_DROPDOWN,
  TICKET_SET_ESCALATION_MODAL_ERROR_TEXT,
  TICKET_TOGGLE_MODAL,
  TICKET_ESCALATION_TOGGLE_MODAL,
  TICKET_UPDATE_ESCALATION_NOTE,
  TICKET_GET_TICKET,
  TICKET_SET_ERRORS,
  TICKET_TOGGLE_LOADING,
  TICKET_ASSIGN_ACTIVITY_IS_OPEN_FIELDS,
  TICKET_TOGGLE_ACTIVITY_IS_OPEN,
  TICKET_TOGGLE_ACTIVITY_CONTENT_LOADING,
  TICKET_SET_ACTIVITY_ERROR,
  TICKET_SET_SHOW_COMMENT_FORM,
  TICKET_SET_COMMENT_VALUE,
  TICKET_SET_DESC_ERROR,
  TICKET_SET_COMMENT_PROCESSING,
  TICKET_SET_ACTIVITY
} from "./types";


export const initialState: ITicketState = {
  loading: false,
  readOnly: true,
  showCommentForm: false,
  commentValue: '',
  descError: false,
  commentProcessing: false,
  reasonDropdownOpen: false,
  ticketModalLoading: false,
  escalationticketModalLoading: false,

  data: {
    id: '',
    ticketNumber: '',
    title: '',
    description: '',
    status: '',
    statusReason: '',
    escalationState: '',
    createdOn: new Date(),
    modifiedOn: new Date(),
    origin: '',
    priority: '',
    openedBy: '',
    activities: [],
    assignedTo: '',
    escalationNote: '',
    modalOpen: false,
    escalationModalOpen: false,
    escalateModalErrorText: '',
    ticketWorker: {
      firstName: '',
      lastName: '',
      name: '',
      email: '',
      phone: null,
    },
  },
  errors: [],
};
export function ticketReducer(state = initialState, action: TicketActionTypes) {

  switch (action.type) {
    case TICKET_TOGGLE_MODAL_LOADING: {

      return {
        ...state,
        ticketModalLoading: !state.ticketModalLoading,

      };

    }

    case TICKET_TOGGLE_ESCALATION_MODAL_LOADING: {

      return {
        ...state,
        escalationticketModalLoading: !state.escalationticketModalLoading,
      };

    }

    case TICKET_ESCALATE_TICKET: {

      return {
        ...state,
        data: {
          ...state.data, escalationState: 'Escalated',
        },
      };

    }
    case TOGGLE_TICKET_REASON_DROPDOWN:

      return {
        ...state,
        reasonDropdownOpen: !state.reasonDropdownOpen,
      };

    case TICKET_SET_ESCALATION_MODAL_ERROR_TEXT:
      return {
        ...state,
        data: {
          ...state.data, escalateModalErrorText: action.payload,
        },
      };
    case TICKET_TOGGLE_MODAL:
      return {
        ...state,
        data: {
          ...state.data, modalOpen: !state.data.modalOpen,
        },
      };
    case TICKET_ESCALATION_TOGGLE_MODAL:
      return {
        ...state,
        data: {
          ...state.data, escalationModalOpen: !state.data.escalationModalOpen, escalationNote: '', escalateModalErrorText: '',
        },
      };
    case TICKET_UPDATE_ESCALATION_NOTE:
      return {
        ...state,
        data: { ...state.data, escalationNote: action.payload, escalateModalErrorText: '' },
      };
    case TICKET_GET_TICKET:
      return {
        ...state,
        data: action.data,
        dataOriginal: action.data,
      };
    case TICKET_SET_ERRORS:
      return {
        ...state,
        errors: [...action.errors],
      };
    case TICKET_TOGGLE_LOADING:
      return {
        ...state,
        loading: !state.loading,
      };
    case TICKET_ASSIGN_ACTIVITY_IS_OPEN_FIELDS:
      return {
        ...state,
        data: { ...state.data, activities: state.data.activities.map((activity) => ({ ...activity, isOpen: false })) },
      };
    case TICKET_TOGGLE_ACTIVITY_IS_OPEN:
      const { data } = state;
      const { activities } = data;
      const { id } = action;
      const updatedActivities = activities.map((activity) => {

        if (activity.id === id) {

          return { ...activity, isOpen: !activity.isOpen };

        }

        return activity;

      });
      return {
        ...state,
        data: { ...state.data, activities: [...updatedActivities] },
      };
    case TICKET_TOGGLE_ACTIVITY_CONTENT_LOADING:
      return {
        ...state,
        data: {
          ...state.data,
          activities: state.data.activities.map((activity) => {

            if (activity.id === action.id) {

              return { ...activity, contentLoading: !activity.contentLoading };

            }

            return activity;

          }),
        },
      };
    case TICKET_SET_ACTIVITY_ERROR:
      return {
        ...state,
        data: {
          ...state.data,
          activities: state.data.activities.map((activity) => {

            if (activity.id === action.id) {

              return { ...activity, error: action.error };

            }

            return activity;

          }),
        },
      };
    case TICKET_SET_SHOW_COMMENT_FORM:
      return {
        ...state, showCommentForm: !state.showCommentForm,
      };
    case TICKET_SET_COMMENT_VALUE:
      return {
        ...state, commentValue: action.value,
      };
    case TICKET_SET_DESC_ERROR:
      return {
        ...state, descError: action.payload,
      };
    case TICKET_SET_COMMENT_PROCESSING:
      return {
        ...state,
        commentProcessing: action.payload,
      };
    case TICKET_SET_ACTIVITY:
      return {
        ...state,
        data: {
          ...state.data,
          activities: state.data.activities.map((activity) => {

            if (activity.id === action.data.id) {

              return { ...activity, ...action.data };

            }

            return activity;

          }),
        },
      };
    default:
      return state;
  }

}
